import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";
import Home from "./routes/Home";
import HostReview from "./routes/HostReview";
import HostLobby from "./routes/HostLobby";
import HostQuestion from "./routes/HostQuestion";
import HostResults from "./routes/HostResults";
import HostEntry from "./routes/HostEntry";
import Join from "./routes/Join";
import PlayWaiting from "./routes/PlayWaiting";
import PlayQuestion from "./routes/PlayQuestion";
import PlayBetween from "./routes/PlayBetween";
import PlayFinished from "./routes/PlayFinished";
import Characters from "./routes/Characters";
import KeepScreenOn from "./components/KeepScreenOn";

export default function App() {
  const { i18n } = useTranslation();
  useEffect(() => {
    const root = document.documentElement;
    root.lang = i18n.language;
    root.dir = i18n.dir(i18n.language);
  }, [i18n, i18n.language]);
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/host" element={<HostReview />} />
      <Route path="/host/lobby" element={<HostLobby />} />
      <Route path="/host/question" element={<HostQuestion />} />
      <Route path="/host/results" element={<HostResults />} />
      {/* /host/:code#h=<token> — teacher deep-link from POST /sessions.
          Must come AFTER the static /host/* routes above so the static
          ones win when their paths match. */}
      <Route path="/host/:code" element={<HostEntry />} />
      <Route path="/join" element={<Join />} />
      <Route path="/join/:sessionCode" element={<Join />} />
      <Route element={<KeepScreenOn />}>
        <Route path="/play/waiting" element={<PlayWaiting />} />
        <Route path="/play/question" element={<PlayQuestion />} />
        <Route path="/play/between" element={<PlayBetween />} />
      </Route>
      <Route path="/play/finished" element={<PlayFinished />} />
      <Route path="/characters" element={<Characters />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
}
